
import ChangeImgUtil from "../../../../engines/components/ChangeImgUtil";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import PageBase from "../../../../engines/modules/uiModule/PageBase";
import { OilFieldOverPrams } from "../../../../engines/modules/uiModule/UIPrams";
import { getOilfieldKengConfig } from "./config/oilfieldConfig";

const { ccclass, property } = cc._decorator;

@ccclass
export default class oilMineOverPage extends PageBase {
    @property({ type: cc.Sprite, displayName: "图片" })
    img_special: cc.Sprite = null;
    @property({ type: cc.Label, displayName: "信息" })
    lab_tips: cc.Label = null;
    @property({ type: cc.Label, displayName: "金额" })
    lab_price: cc.Label = null;
    @property({ type: cc.Label, displayName: "收益" })
    lab_getMoney: cc.Label = null;
    @property({ type: ChangeImgUtil, displayName: "赚亏" })
    node_change: ChangeImgUtil = null;

    callBack: () => void = null;

    prams: OilFieldOverPrams = null;

    private bWin = false;
    async OnPageOpen(prams?: OilFieldOverPrams) {
        if (prams) {
            this.prams = prams;
            let info = getOilfieldKengConfig[prams.id];
            this.img_special.spriteFrame = prams.spriteFrams;
            this.lab_tips.string = info.tips;

            this.lab_price.string = data_control.getNumberFormat(info.getMoney);
            this.lab_getMoney.string = data_control.getNumberFormat(info.getMoney - prams.buyPrice);
            this.callBack = prams.callBack;
            this.node_change.node.active = info.getMoney != prams.buyPrice
            
            if (this.node_change.node.active) {
                let bWin = this.bWin = info.getMoney > prams.buyPrice;
                this.node_change.changeImgById(bWin ? 0 : 1);
                this.lab_getMoney.node.color = bWin ? cc.color(0x7A, 0xB2, 0x26) : cc.color(0xCE, 0x5C, 0x3F);
            }
        }
        super.OnPageOpen(prams)
    }
    
    onClickSure(event: cc.Event.EventTouch) {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        // let info = getOilfieldKengConfig[this.prams.id]
        // let node = event.getCurrentTarget();
        // if (info.getMoney != null) {
        //     O1HD.getServices().userSrv.setCoins(info.getMoney, true, node);
        // }
        this.OnCloseBtn();
        this.callBack && this.callBack();
    }
}